"use client";
import { Breadcrumbs, BreadcrumbItem } from "@nextui-org/react";
import Link from "next/link";

const CustomBreadcrumbs = ({ text }) => {
  return (
    <Breadcrumbs>
      <BreadcrumbItem>
        <Link href="/" className="text-black">
          Home
        </Link>
      </BreadcrumbItem>
      <BreadcrumbItem>{text}</BreadcrumbItem>
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
